import React, { Fragment } from 'react'

import { Button, Modal } from 'react-bootstrap'

// icons
import {
    faArrowLeft,
    faCheck,
    faCreditCard,
    faDollarSign,
    faMinusCircle,
    faMoneyBill,
    faPlus,
    faPlusCircle,
    faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// router
import { withRouter } from 'react-router-dom'

// sweet alert

// css
import FacturaElectronicaModal from '../FacturaElectronicaModal/FacturaElectronicaModal'
import useFinalizarVentaModal from '../hooks/useFinalizarVentaModal'
import './FinalizarVentaModal.css'

const FinalizarVentaModal = ({
    ventaDatos,
    show,
    handleShow,
    handleClose,
    reset,
    isLoad,
}) => {
    const {
        handleShowFirst,
        mediosPagos,
        medioPago,
        setMedioPago,
        monto,
        setMonto,
        recargoDescuento,
        setRecargoDescuento,
        tarjeta,
        setTarjeta,
        tarjetas,
        cantidadCuotasTarjeta,
        setCantidadCuotasTarjeta,
        nombreTitular,
        setNombreTitular,
        numeroTarjeta,
        setNumeroTarjeta,
        numeroLote,
        setnumeroLote,
        agregarCobroParcializado,
        cobrosParcializados,
        finalizarVenta,
        deleteItemCobroParcializado,
        getVentaFE,
        showFE,
        handleShowFE,
        handleCloseFE,
        isDisabledButton,
        total,
        saldo
    } = useFinalizarVentaModal(
        ventaDatos,
        handleShow,
        handleClose,
        isLoad,
        reset
    )

    return (
        <Fragment>
            <Button
                onClick={handleShowFirst}
                variant="outline-danger"
                size="lg"
                className="widthCobrar"
                disabled={isDisabledButton}
            >
                Cobrar <FontAwesomeIcon icon={faMoneyBill} />
            </Button>
            <Modal
                backdrop="static"
                show={show}
                onHide={handleClose}
                size="xl"
                contentClassName={`centrado ${showFE ? 'modal-blurred' : 'modal-normal'}`}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Formas de pago</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row mb-4">
                        <div className="col-md-6">
                            <div className="card bg-light">
                                <div className="card-body text-center">
                                    <h5 className="card-title text-muted mb-1">Total de la Venta</h5>
                                    <h3 className="card-text text-primary font-weight-bold">
                                        ${parseFloat(total).toFixed(2)}
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card bg-light">
                                <div className="card-body text-center">
                                    <h5 className="card-title text-muted mb-1">Saldo Pendiente</h5>
                                    <h3 className={`card-text font-weight-bold ${saldo > 0 ? 'text-danger' : 'text-success'}`}>
                                        ${parseFloat(saldo).toFixed(2)}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* MEDIOS DE PAGO, MONTO, DESCUENTO / RECARGO */}
                    <div className="form-row">
                        <div className="form-group col-md">
                            <label htmlFor="inputMedioPago">
                                Medio de pago
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faMoneyBill} />
                                </span>
                                <select
                                    id="inputMedioPago"
                                    className="custom-select"
                                    name="medioPago"
                                    value={medioPago}
                                    onChange={(e) =>
                                        setMedioPago(e.target.value)
                                    }
                                >
                                    {mediosPagos.map((mp, index) => (
                                        <option key={index} value={mp.id}>
                                            {mp.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="form-group col-md">
                            <label htmlFor="inputMonto">Monto</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faDollarSign} />
                                </span>
                                <input
                                    type="number"
                                    step="any"
                                    className="form-control"
                                    id="inputMonto"
                                    name="monto"
                                    placeholder="Monto"
                                    value={monto}
                                    onChange={(e) => setMonto(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="form-group col-md">
                            <label htmlFor="inputRecargoDescuento">
                                Recargos/Descuentos +/-
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faPlusCircle} /> /{' '}
                                    <FontAwesomeIcon icon={faMinusCircle} />
                                </span>
                                <input
                                    type="number"
                                    step="any"
                                    className="form-control"
                                    id="inputRecargoDescuento"
                                    name="recargoDescuento"
                                    placeholder="recargo o descuento"
                                    defaultValue={recargoDescuento}
                                    onChange={(e) =>
                                        setRecargoDescuento(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    {parseInt(medioPago, 10) === 2 ? (
                        // SI EL MEDIO DE PAGO ES TARJETA
                        <div className="fade-in-image">
                            <div className="form-row">
                                <div className="form-group col-md">
                                    <label htmlFor="inputTarjeta">
                                        Tarjetas
                                    </label>
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon
                                                icon={faCreditCard}
                                            />
                                        </span>
                                        <select
                                            id="inputTarjeta"
                                            className="custom-select"
                                            name="tarjeta"
                                            value={tarjeta}
                                            onChange={(e) =>
                                                setTarjeta(e.target.value)
                                            }
                                        >
                                            <option value={null}>
                                                -- SELECCIONE TARJETA --
                                            </option>
                                            {tarjetas.map((t, index) => (
                                                <option
                                                    key={index}
                                                    value={t.id}
                                                >
                                                    {t.nombre}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group col-md">
                                    <label htmlFor="inputCuotas">
                                        Cantidad de cuotas
                                    </label>
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon
                                                icon={faCreditCard}
                                            />
                                        </span>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="inputCantidadCuotas"
                                            name="cuotas"
                                            value={cantidadCuotasTarjeta}
                                            onChange={(e) =>
                                                setCantidadCuotasTarjeta(
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="form-group col-md">
                                    <label htmlFor="inputNombreTitular">
                                        Nombre del titular
                                    </label>
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon
                                                icon={faCreditCard}
                                            />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="inputNombreTitular"
                                            name="nombreTitular"
                                            placeholder=""
                                            value={nombreTitular}
                                            onChange={(e) =>
                                                setNombreTitular(e.target.value)
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="form-group col-md">
                                    <label htmlFor="inputNTarjeta">
                                        Numero tarjeta
                                    </label>
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon
                                                icon={faCreditCard}
                                            />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="inputNTarjeta"
                                            name="precio"
                                            placeholder="Ingrese los ultimos 4 dígitos."
                                            value={numeroTarjeta}
                                            onChange={(e) =>
                                                setNumeroTarjeta(e.target.value)
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="form-group col-md">
                                    <label htmlFor="inputNAutorizacion">
                                        Nro autorización / lote
                                    </label>
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon
                                                icon={faCreditCard}
                                            />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="inputNAutorizacion"
                                            name="precio"
                                            placeholder=""
                                            value={numeroLote}
                                            onChange={(e) =>
                                                setnumeroLote(e.target.value)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}

                    <div className="p-2 row justify-content-center">
                        <button
                            className="btn btn-outline-info"
                            onClick={agregarCobroParcializado}
                        >
                            <FontAwesomeIcon icon={faPlus} /> Agregar
                        </button>
                    </div>

                    {/* MEDIOS DE PAGOS INGRESADOS */}
                    <div className="p-2">
                        <table className="table centrado">
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col">Forma de Pago</th>
                                    <th scope="col">Monto</th>
                                    <th scope="col">Eliminar</th>
                                </tr>
                            </thead>

                            <tbody>
                                {cobrosParcializados
                                    ? cobrosParcializados.map((cb, index) => {
                                        return (
                                            <tr key={parseInt(index)}>
                                                <td>{cb.medioPago.nombre}</td>
                                                <td>
                                                    $
                                                    {parseFloat(
                                                        cb.monto
                                                    ).toFixed(2)}
                                                </td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary"
                                                        onClick={() => {
                                                            deleteItemCobroParcializado(
                                                                cb,
                                                                index
                                                            )
                                                        }}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faTrashAlt}
                                                        />
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                    : null}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button
                        className="btn btn-outline-primary btn-lg col mr-1 ml-1"
                        onClick={handleClose}
                    >
                        Volver <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    <button
                        className="btn btn-outline-success btn-lg col mr-1 ml-1"
                        onClick={finalizarVenta}
                    >
                        Finalizar Venta <FontAwesomeIcon icon={faCheck} />
                    </button>
                    <FacturaElectronicaModal
                        getVentaFE={getVentaFE}
                        isLoad={true}
                        showFE={showFE}
                        handleShowFE={handleShowFE}
                        handleCloseFE={handleCloseFE}
                        handleClose={handleClose}
                        reset={reset}
                    />
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}

export default withRouter(FinalizarVentaModal)
